import { NgModule } from '@angular/core';
import { CastAnyPipe } from './cast-any.pipe';

@NgModule({
  imports: [],
  declarations: [CastAnyPipe],
  exports: [CastAnyPipe],
  providers: [CastAnyPipe],
})
export class CastAnyPipeModule {}
